module.exports = "/_next/static/images/9f227f2f6f6f0f0c7491903aaf0f47ba-nobureaucracy@0.75x.png";